import axios from 'axios';
import { removeCache } from './index';
import { getDeviceId, removeDeviceId } from '../utils';

interface SignInProps {
  email?: string;
  password?: string;
}

class AuthService {
  signin = (props?: SignInProps) =>
    axios.post(`/auth/login`, {
      email: props?.email,
      password: props?.password,
      deviceId: getDeviceId(),
    });

  logout = () => {
    localStorage.removeItem('user');
    removeDeviceId();
    removeCache('*');

    return Promise.resolve(true);
  };

  logoutOnError = () => {
    localStorage.removeItem('user');
    removeDeviceId();
    removeCache('*');

    window.location.href = '/signin';
  };
}

export const authService = new AuthService();
